<app-entity-page
    [closeClicked]="closeClicked"
    [detailsContentTitle]="getDetailsTitle()"
    [mapContentTitle]="'iaa.conservationArchive.mapTitle' | translate"
    [loading]="documentDetailsLoading">
    <ng-template #detailsContent>
        <div class="conservation-document-content">
            <conservation-archive-document-details
                [details]="documentDetails"
                [currentLanguage]="currentLanguage$"
                [onViewFolder]="onViewFolder.bind(this)"
                [onViewSite]="onViewSite.bind(this)"
                [onDownload]="onDownload.bind(this)">
            </conservation-archive-document-details>
        </div>
    </ng-template>

    <ng-template #mapContent>
        <div class="conservation-document-map">
            <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls" [extentAll]="true"></app-arcgis-map>
        </div>
    </ng-template>

    <ng-template #footer>
        <div class="actions-footer">
            <p-button
              styleClass="icon-button"
              [ngClass]="{'icon-button':true,'en': (currentLanguage$ | async)=== 'en'}"
              [link]="true"
              icon="pi pi-download"
              [label]="'iaa.conservationArchive.document.download' | translate"
              [tabindex]="0"
              [disabled]="!documentDetails.hasScan || !documentDetails.documentDownloadUrl"
              [ariaLabel]="'iaa.aria.downloadDoc' | translate"
              (click)="onDownload()"></p-button>
        </div>
    </ng-template>
</app-entity-page>
